import { IconProps } from '@chakra-ui/react';

import { SlackIcon } from '@components/icons';
import { lang } from '@lang';
import { ActionPanelMode, projectState, selectActionPanelIsOpen, selectActionPanelMode, setActionPanelIsOpen, setActionPanelMode, useAppDispatch, useAppSelector } from '@state';
import { Feature, FeatureHoookParams } from '..';

type UseSlackFeatureParams = FeatureHoookParams;
export const useSlackFeature = (_params: UseSlackFeatureParams = {}): Feature<boolean> => {
	const dispatch = useAppDispatch();
	const project = useAppSelector(projectState);
	const actionPanelIsOpen = useAppSelector(selectActionPanelIsOpen);
	const actionPanelMode = useAppSelector(selectActionPanelMode);

	const [disabled, tooltip] = (() => {
		if (project.length > 0) return [false, lang.crm.tooltip.openSlackFeatures];
		return [true, lang.crm.tooltip.disabledSlack];
	})();

	return {
		name: 'slack',
		label: lang.crm.label.slack,
		shortcut: '',
		tooltip,
		icon: (props = {}) => <SlackIcon {...props as IconProps} />,
		disabled,
		value: false,
		hidden: false,
		handler: () => {
			dispatch(setActionPanelIsOpen(actionPanelMode === ActionPanelMode.Slack ? !actionPanelIsOpen : true));
			dispatch(setActionPanelMode(ActionPanelMode.Slack));
		}
	};
};
